import { render } from "./HotPointHistoryComponent.vue?vue&type=template&id=7033becc&scoped=true"
import script from "./HotPointHistoryComponent.vue?vue&type=script&lang=js"
export * from "./HotPointHistoryComponent.vue?vue&type=script&lang=js"

import "./HotPointHistoryComponent.vue?vue&type=style&index=0&id=7033becc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7033becc"]])

export default __exports__